import React, {Component} from 'react';
import InputMask from 'react-input-mask';

export default class PlateInput extends Component {

    onChange = (event) => {
        let value = event.target.value;
        this.props.action(this.props.name, value);
    };

    isDigit = (val) => {
        return !isNaN(parseInt(val, 10))
    };

    render() {

        let {value} = this.props;
        value = value.toUpperCase();
        let firstChar = value.charAt(0);
        let thirdChar = value.charAt(2);

        if(this.isDigit(firstChar)){
            return <InputMask
                placeholder={this.props.placeholder}
                mask="999-aaa-999"
                value={value}
                onChange={this.onChange}
            />;
        }else if(firstChar !== '_'){
            if (thirdChar === '-' || this.isDigit(thirdChar)) {
                return <InputMask
                    placeholder={this.props.placeholder}
                    mask="aa-999-aa"
                    value={value}
                    onChange={this.onChange}
                />;
            }
        }


        return <InputMask
            placeholder={this.props.placeholder}
            mask="*a*-999"
            value={value}
            onChange={this.onChange}
        />;
    }
}


PlateInput.deaultProps = {
    placeholder: '',
    value: '',
    action: () => {},
    name: ''
};


// WEBPACK FOOTER //
// ./src/components/PlateInput/plateInput.js